<template>
  <div class="iv-message">
    <div class="iv-main-width iv-p-t-20">
      <template v-if="show">
        <List
          type="opinionsed"
          v-if="list.length > 0"
          :showPage="true" 
          :map="map" 
          :total="total" 
          :list="list"
          :current="currentPage"
          :pageSize="pageSize"
          class="iv-m-t-24" 
          @on-detail="onDetailPage" 
          @on-change="onChangePage"
          @on-page-size-change="onChangePageSize">
        </List>
        <NoData v-else message="暂无消息"></NoData>
      </template>
    </div>
  </div>
</template>

<script>
import columns from './columns'
import List from '../activeList'
import NoData from '@/components/no-data'
import TreeList from '@/components/drag-table-inline'
export default {
  data () {
    return {
      operationList: [],
      show: true,
      columns: [],
      selectionChange: [],
      list: [],
      map: {
        title: 'title',
        launchOrgName: 'launchOrgName',
        startDate: 'startDate',
        endDate: 'endDate',
        publishScope: 'publishScope',
        publishState: 'publishState',
        feedbackState: 'feedbackState'
      },
      count: 0,
      total: 0,
      currentPage: 1,
      pageSize: 5
    }
  },
  provide () {
    return {
      operateClick: this.operateClick
    }
  },
  async created () {
    this.getlistUserAccept()
    this.columns = columns.call(this)
  },
  methods: {
    operateClick (item, type) {
      switch (type) {
        case 'see':
          this.$router.push({
            name: 'feedbackOpinions',
            query: {
              type: 'see',
              title: '查看意见',
              objectId: item.objectId
            }
          })
          break
      }
    },
    // 门户-征集意见列表
    getlistUserAccept () {
      this.$ajax({
        url: 'api-uum/collectOpinion/listUserAccept',
        method: 'GET',
        data: {
          publishState: 'finish'
        }
      }).then(data => {
        let res = data.data.data
        this.total = data.data.count
        this.list = res
      })
    },
    onDetailPage (item, name) {
      switch (name) {
        case 'see':
          this.$router.push({
            name: 'feedbackOpinions',
            query: {
              type: 'see',
              title: '查看意见',
              objectId: item.objectId
            }
          })
          break
      }
    },
    onChangePage (page) {
      this.currentPage = page
      this.getlistUserAccept()
    },
    onChangePageSize (page) {
      this.pageSize = page
      this.getlistUserAccept()
    }
  },
  components: {
    List,
    NoData,
    TreeList,
  }
}
</script>

<style lang="scss" scoped>
.iv-message {
  height: 100%;;
  background-color: #fff;
  /deep/ .iv-drag-table {
    .ivu-table-row {
      .ivu-table-cell {
        font-size: 14px !important;
        color: rgba($color: #000000, $alpha: 0.65);
      }
    }
  }
}
.iv-toubu {
  display: flex;
  width: 1200px;
  flex-wrap: wrap;
  // justify-content: space-around;
}
.iv-form {
  width: 400px;
  display: inline-block;
  justify-content: space-between;
}
.iv-form-kuang, .ivu-date-picker {
  width: 302px !important;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
}
/deep/ .ivu-input {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
/deep/ .ivu-select-placeholder {
  height: 40px !important;
  line-height: 40px !important;
}
/deep/ .ivu-select-selection {
  height: 40px !important;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 40px;
}
/deep/ .ivu-select-arrow {
  margin-top: -5px;
}
/deep/ .ivu-form-item-label {
  color: rgba($color: #000000, $alpha: 0.65);
  font-size: 14px;
}
.iv-botton {
  float: right;
  // margin-top: 10px;
  width: 400px;
}
.iv-tijiao {
  border-radius: 8px;
  width: 88px;
  height: 40px;
  margin-left: 116px;
}
.iv-cancel {
  border-radius: 8px;
  width: 88px;
  height: 40px;
}
.iv-heng {
  height: 1px;
  background: rgba(0, 0, 0, 0.15);
  // border: 1px solid rgba(0, 0, 0, 0.15);
  margin: 20px 0;
}
.iv-box {
  width: 1200px;
  height: 40px;
  .iv-yidu {
    float: right;
    width: 128px;
  }
  .iv-weidu {
    float: right;
    width: 96px;
  }
}
</style>
